import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import RespuestaServidor from './RespuestaServidor';

const NotAllowed = () => {
  return (
    <RespuestaServidor
      titulo="No autorizado"
      texto="Lo sentimos, no tienes permisos para ver esta página. Intenta iniciar sesión nuevamente."
      icono={PriorityHighIcon}
      textoBoton="Volver"
      colorIcono="primary"
      paginaANavegar={-1}
    />
  );
};

export default NotAllowed;
